<template>
  <v-container>
    <v-layout>
      <v-flex xs12 md6 text-xs-center>Template: {{ template.name }}</v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md6 text-xs-center
        >Description: {{ template.description }}</v-flex
      >
    </v-layout>
    <v-layout>
      <v-flex>
        <v-data-table :headers="productTableHeaders" :items="templateItems">
          <template v-slot:item.quantity="{ item }">
            <v-text-field
              outlined
              type="number"
              dense
              min="0"
              label="Qty"
              class="mt-4 pa-2"
              v-model="item.quantity"
            />
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Table from "@/components/Table";

export default {
  name: "TemplateOrder",
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  computed: {
    templateItems() {
      return this.template.items;
    },
  },

  data() {
    return {
      productTableHeaders: [
        {
          text: "Product ID",
          value: "productCode",
        },
        {
          text: "Manufacturer",
          value: "manufacturer",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "Price",
          value: "price.formattedPrice",
          width: "10%",
        },
        {
          text: "Qty",
          value: "quantity",
          sortable: false,
          width: "10%",
        },
      ],
    };
  },
};
</script>

<style scoped>
/* TODO - combine this css style */
.v-data-table >>> .v-data-table__wrapper td,
.v-data-table >>> .v-data-table__wrapper th {
  padding: 5px;
}

@media all and (max-width: 640px) {
  .v-data-table >>> .v-data-table__wrapper table,
  .v-data-table >>> .v-data-table__wrapper thead,
  .v-data-table >>> .v-data-table__wrapper tbody,
  .v-data-table >>> .v-data-table__wrapper th,
  .v-data-table >>> .v-data-table__wrapper td,
  .v-data-table >>> .v-data-table__wrapper tr {
    display: block;
  }
  .v-data-table >>> .v-data-table__wrapper td {
    height: auto;
    border: none !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr {
    padding: 5px;
  }

  .v-data-table >>> .v-data-table__wrapper .v-data-table__mobile-row__cell {
    text-align: left !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr:nth-of-type(even) {
    background: #eee;
  }

  .v-data-table >>> .v-data-table__wrapper th {
    margin-bottom: 15px;
    border: none !important;
  }
}
</style>

<style scoped>
/* TODO - combine this css style */
.v-data-table >>> .v-data-table__wrapper td,
.v-data-table >>> .v-data-table__wrapper th {
  padding: 5px;
}

@media all and (max-width: 640px) {
  .v-data-table >>> .v-data-table__wrapper table,
  .v-data-table >>> .v-data-table__wrapper thead,
  .v-data-table >>> .v-data-table__wrapper tbody,
  .v-data-table >>> .v-data-table__wrapper th,
  .v-data-table >>> .v-data-table__wrapper td,
  .v-data-table >>> .v-data-table__wrapper tr {
    display: block;
  }
  .v-data-table >>> .v-data-table__wrapper td {
    height: auto;
    border: none !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr {
    padding: 5px;
  }

  .v-data-table >>> .v-data-table__wrapper .v-data-table__mobile-row__cell {
    text-align: left !important;
  }

  .v-data-table >>> .v-data-table__wrapper tr:nth-of-type(even) {
    background: #eee;
  }

  .v-data-table >>> .v-data-table__wrapper th {
    margin-bottom: 15px;
    border: none !important;
  }
}
</style>